var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.wasModified() || !_vm.old || !_vm.otherName)?_c('div',[_c('v-flex',{attrs:{"d-flex":"","xs12":""}},[_c('v-card',{attrs:{"color":_vm.color()}},[_c('v-card-text',[_c('strong',[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.parentSerialNumber)+_vm._s(_vm.parentSerialNumber ? "." : "")+_vm._s(_vm.serialNumber)+"  "+_vm._s(_vm.name)+"\n\t\t\t\t\t"+_vm._s(_vm.status())+"\n\t\t\t\t")])])],1)],1),_c('final-report-comparison-large-row',{attrs:{"old":_vm.old,"first-cell-label":"","cells-color-intensity":-4,"first-cell-color":_vm.color(),"cells-formatter":_vm.formatMoney,"other-exists":(_vm.otherName !== undefined && _vm.otherName !== null && _vm.otherName !== ''),"cells-values":[_vm.cost.fromProjectSum,
			_vm.fromDotationFromProject(_vm.cost),
			_vm.fromOtherFromProject(_vm.cost),
			_vm.fromOwnHumanFromProject(_vm.cost),
			_vm.fromOwnInKindFromProject(_vm.cost),
			_vm.cost.fromDocumentSum,
			_vm.fromDotationFromDocument(_vm.cost),
			_vm.fromOtherFromDocument(_vm.cost),
			_vm.fromOwnHumanFromDocument(_vm.cost),
			_vm.fromOwnInKindFromDocument(_vm.cost),
			_vm.fromInterestsFromDocument(_vm.cost)],"cells-other-values":[_vm.otherCost.fromProjectSum,
			_vm.fromDotationFromProject(_vm.otherCost),
			_vm.fromOtherFromProject(_vm.otherCost),
			_vm.fromOwnHumanFromProject(_vm.otherCost),
			_vm.fromOwnInKindFromProject(_vm.otherCost),
			_vm.otherCost.fromDocumentSum,
			_vm.fromDotationFromDocument(_vm.otherCost),
			_vm.fromOtherFromDocument(_vm.otherCost),
			_vm.fromOwnHumanFromDocument(_vm.otherCost),
			_vm.fromOwnInKindFromDocument(_vm.otherCost),
			_vm.fromInterestsFromDocument(_vm.otherCost)]}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }